import { compact, uniq } from 'lodash'

import { ADDITIONAL_DATA_KEY, MAIN_DATA_KEY } from 'modules/Monitoring/consts/chart'
import { ChartData } from 'modules/Monitoring/types'

type ChartDataItem = ChartData[number]

const createDateLookupMap = (data: ChartData): Map<string | number, ChartDataItem> => {
  return new Map(data.map(item => [item.date, item]))
}

const mergeSingleDataItem = (
  dataItem?: ChartDataItem,
  additionalDataItem?: ChartDataItem,
): ChartDataItem | undefined => {
  const baseItem = dataItem ?? additionalDataItem

  if (!baseItem) {
    throw new Error('Attempted to merge two undefined data items.')
  }

  if (!dataItem?.[MAIN_DATA_KEY]) {
    return undefined
  }

  return {
    ...baseItem,
    date: baseItem.date,
    [MAIN_DATA_KEY]: dataItem[MAIN_DATA_KEY],
    [ADDITIONAL_DATA_KEY]: additionalDataItem?.[MAIN_DATA_KEY],
  }
}

export const mergeChartAdditionData = (
  data: ChartData,
  additionData: ChartData,
): ChartData => {
  const dataMap = createDateLookupMap(data)
  const additionDataMap = createDateLookupMap(additionData)

  const allDates = uniq([...dataMap.keys(), ...additionDataMap.keys()])

  return compact(
    allDates
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      .map(date => {
        const dataItem = dataMap.get(date)
        const additionalDataItem = additionDataMap.get(date)

        return mergeSingleDataItem(dataItem, additionalDataItem)
      }),
  )
}
